import { jsx as _jsx } from "react/jsx-runtime";
import { Group, HourglassEmpty, Person } from "@mui/icons-material";
import { EmptyState } from "../../shared/EmptyState";
export const PriorityInvitesEmptyState = ({ onModalOpen }) => {
    return (_jsx(EmptyState, { backgroundIcon: Group, primaryIcon: Person, accentIcon: HourglassEmpty, title: "No Found Invites", description: "When you send invitations, they will appear here. This is where you can track outgoing invitations and follow up if needed.", action: onModalOpen
            ? { label: "Send Invite", onClick: onModalOpen }
            : undefined }));
};
